var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-calendar',{attrs:{"type":"range","title":_vm.title,"min-date":_vm.minDate,"max-date":_vm.maxDate,"formatter":_vm.formatter,"default-date":null},on:{"confirm":_vm.onConfirm,"close":_vm.onCancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }